// The objects whose duplicates merge (recordMerge.tsx): a list's Merge action and
// a record page's "Merge with Another …" appear for these only.
import type { ObjectKey } from '../navigation';
import { ACCOUNT_MERGE } from './accountMerge';
import { CONTACT_MERGE } from './contactMerge';
import type { MergeSpec } from './recordMerge';

const MERGE_SPECS: Partial<Record<ObjectKey, MergeSpec>> = {
  accounts: ACCOUNT_MERGE,
  contacts: CONTACT_MERGE,
};

/** The object's merge, or null when its records do not merge. */
export const mergeSpecOf = (object: ObjectKey): MergeSpec | null => MERGE_SPECS[object] ?? null;
